import { Box, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import WhatIs from "./components/WhatIs";
import LifePathNumber from "./components/LifePathNumber";

// import ZodiacList from "./components/ZodiacList";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <Box
      sx={{
        flex: 1,
        overflowY: "auto",
      }}
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ width: "100%", height: "100%" }}>{children}</Box>
      )}
    </Box>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const WhatIsNumerology = () => {
  const [value, setValue] = useState(0);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };
  const tabs = [
    {
      code: "WhatIs",
      name: "What is numerology?",
      component: WhatIs,
    },
    {
      code: "LifePathNumber",
      name: "Life Path & Destiny Number",
      component: LifePathNumber,
    },
  ];

  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs
          value={value}
          onChange={handleChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          {tabs.map((tab, index) => (
            <Tab
              label={tab.name}
              {...a11yProps(index)}
              sx={{
                textTransform: "unset",
                "&.Mui-selected": {
                  fontWeight: "bold",
                },
              }}
            />
          ))}
        </Tabs>
      </Box>
      {tabs.map((tab, index) => (
        <CustomTabPanel value={value} index={index}>
          {<tab.component />}
        </CustomTabPanel>
      ))}
    </Box>
  );
};

export default WhatIsNumerology;
